import { useState } from 'react';
import MadfuWidgetModal from '../ui/modals/madfu-widget-modal';
import NextImage from '../ui/next-image';

const MadfuWidget = ({ locale, total }) => {
  const [show, setShow] = useState(false);
  return (
    <div className='mt-2 flex items-center justify-center rounded-md bg-white max-[470px]:items-start max-[470px]:justify-start'>
      <p
        onClick={() => setShow(true)}
        className='text-md flex w-full cursor-pointer items-center gap-4 rounded-md sm:p-2 md:p-3'
      >
        <NextImage
          loading='eager'
          priority='high'
          src={`/imgs/payments/madfu-logo-${locale}.png`}
          alt='madfu logo'
          height={120}
          width={120}
          className='w-20 object-contain max-lg:h-5 max-lg:w-16'
        />
        <span className='text-sm max-sm:text-xs'>
          {locale === 'en'
            ? 'Split your order up to 4 Payments - interest free, Sharia law Complient'
            : 'قسم طلبك حتى 4 دفعات - خالي من الفوائد, متوافق مع الشريعة الإسلامية'}
        </span>
      </p>
      <MadfuWidgetModal
        locale={locale}
        onHide={() => setShow(false)}
        price={total}
        show={show}
        installments={4}
      />
    </div>
  );
};

export default MadfuWidget;
